<div class="modal-header">
  <h4 class="modal-title">{{ 'Import from CSV' | translate }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
</div>

<div class="modal-body">
  <div class="upload-section d-flex justify-content-between">
    <div class="file-action">
      <button (click)="fileInput.click()" class="btn btn-primary">
        <i class="fa fa-upload"></i>&nbsp;{{ 'Upload Data from File' | translate }}
      </button>
      <p>{{ '.csv, .xlsx spreadsheets accepted.' | translate }}</p>
      <input type="file" #fileInput (change)="onFileChange($event, formatMismatchModal)" style="display: none;" />
    </div>

    <div class="description">
      <p>
        {{ "You can upload any .csv or .xlsx file with columns as long as it has one record per row. The next step will allow you to match your spreadsheet columns to the right data points. You'll be able to clean up or remove any corrupted data before finalizing your report." | translate }}
      </p>
    </div>
  </div>

  <div class="info-section mt-4">
    <h5 class="text-primary"><i class="fa fa-info-circle"></i> {{ 'Required Format for' | translate }} {{ type | uppercase }}</h5>
    <p>
      {{ "Ensure your file includes these mandatory (highlighted) columns." | translate }}
    </p>
    <div class="table-section">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <ng-container *ngFor="let header of sampleHeaders">
              <th class="mandatory-column" [ngClass]="{
                'highlight': mandatoryColumnMap[type].includes(header)
              }">
              {{ header }}
            </th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of sampleData">
            <td *ngFor="let cell of row">
              <em>{{ cell || 'Example Data' }}</em>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <button class="btn btn-outline-success mt-2" (click)="downloadSample()">
      <i class="fa fa-file-excel"></i> {{ 'Download Sample File' | translate }}
    </button>
  </div>

  <div class="table-section mt-3" *ngIf="importedData.length > 0">
    <h5 class="text-primary">{{ 'Preview Uploaded Data' | translate }}</h5>
    <table class="table table-responsive table-striped">
      <thead>
        <tr>
          <ng-container *ngFor="let header of headers">
            <th [ngClass]="{ 'highlight': mandatoryColumnMap[type].includes(header) }">
              {{ header }}
            </th>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of importedData">
          <td *ngFor="let cell of row">{{ cell }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="clearData()">
    <i class="fa fa-trash"></i> {{ 'Clear Data' | translate }}
  </button>
  <button class="btn btn-success" (click)="onSave()" [disabled]="!selectedFile">
    <i class="fa fa-check-circle"></i> {{ 'Continue' | translate }}
  </button>
</div>
<app-toast-container></app-toast-container>

<!-- Popup for Format Mismatch -->
<ng-template #formatMismatchModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ 'Format Mismatch' | translate }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
  </div>
  <div class="modal-body">
    <p>{{ 'The uploaded file does not match the expected format. Please download and use the correct template.' | translate }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onCancel()">{{ 'Close' | translate }}</button>
    <button type="button" class="btn btn-outline-success" (click)="downloadSample()"><i class="fa fa-file-excel"></i>&nbsp;{{ 'Download Sample' | translate }}</button>
  </div>
</ng-template>

